<template>
  <div v-if="isVisible" class="mobile-app-banner">
    <div class="banner-inner">
      <!-- Close Button -->
      <button class="close-banner-btn" @click="closeBanner" aria-label="Close app banner">
        <img
          src="@/assets/imgs/newhomepage/arrow-4x-cross.png"
          alt="Close"
          class="close-banner-img"
        />
      </button>

      <!-- App Logo Rounded Card -->
      <div class="app-logo-card">
        <img src="@/assets/imgs/newhomepage/pro-hire3x.svg" alt="App Logo" class="app-logo" />
      </div>

      <!-- Text Section -->
      <div class="banner-text-sec">
        <div class="banner-title font-inter fs-16 fw-600 color-2E425D">Get the App</div>
        <div class="banner-subtitle font-inter fs-12 fw-400 color-606060">
          Assess, Train and Get Hired 3X Faster...
        </div>
      </div>

      <!-- Download Button -->
      <a
        href="https://play.google.com/store/apps/details?id=com.hire3x.candidate"
        target="_blank"
        rel="noopener noreferrer"
        class="download-btn font-inter fs-12 fw-500 color-white"
      >
        Download Now
      </a>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/eventBus";

export default {
  name: "MobileGetAppBanner",
  data() {
    return {
      isDismissed: false,
      isResumeClinicOpen: false,
      isSearchOpen: false,
      isLoginOpen: false,
    };
  },
  computed: {
    isVisible() {
      return !this.isDismissed && !this.isResumeClinicOpen && !this.isSearchOpen && !this.isLoginOpen;
    }
  },
  watch: {
    isVisible(val) {
      if (val) {
        document.body.classList.add("has-mobile-banner");
      } else {
        document.body.classList.remove("has-mobile-banner");
      }
    }
  },
  mounted() {
    // Show banner only if it was not dismissed in the current session
    this.isDismissed = !!sessionStorage.getItem("hire3x_mobile_banner_dismissed");
    if (this.isVisible) {
      document.body.classList.add("has-mobile-banner");
    }

    this.onResumeClinicOpened = () => {
      this.isResumeClinicOpen = true;
    };
    this.onResumeClinicClosed = () => {
      this.isResumeClinicOpen = false;
    };
    this.onSearchStateChanged = (isActive) => {
      this.isSearchOpen = !!isActive;
    };
    this.onLoginOpened = () => {
      this.isLoginOpen = true;
    };
    this.onLoginClosed = () => {
      this.isLoginOpen = false;
    };

    EventBus.$on("resume-clinic-opened", this.onResumeClinicOpened);
    EventBus.$on("resume-clinic-closed", this.onResumeClinicClosed);
    EventBus.$on("header-search-state", this.onSearchStateChanged);
    EventBus.$on("open-login-modal", this.onLoginOpened);
    EventBus.$on("close-login-modal", this.onLoginClosed);
  },
  beforeDestroy() {
    document.body.classList.remove("has-mobile-banner");
    EventBus.$off("resume-clinic-opened", this.onResumeClinicOpened);
    EventBus.$off("resume-clinic-closed", this.onResumeClinicClosed);
    EventBus.$off("header-search-state", this.onSearchStateChanged);
    EventBus.$off("open-login-modal", this.onLoginOpened);
    EventBus.$off("close-login-modal", this.onLoginClosed);
  },
  methods: {
    closeBanner() {
      this.isDismissed = true;
      sessionStorage.setItem("hire3x_mobile_banner_dismissed", "true");
    },
  },
};
</script>

<style scoped>
/* Mobile Banner container styling */
.mobile-app-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: #ffffff;
  z-index: 1052; /* Sits above the mobile header which is 1051 */
  border-bottom: 1px solid #efefef;
  display: none; /* Hidden on desktop by default */
  box-sizing: border-box;
}

/* Banner inner elements styling */
.banner-inner {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 16px;
  gap: 12px;
}

.close-banner-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.close-banner-img {
  width: 14px;
  height: 14px;
  object-fit: contain;
  display: block;
}

.app-logo-card {
  width: 42px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #efefef;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.app-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.banner-text-sec {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  text-align: left;
  min-width: 0; /* Ensures text truncation ellipsis works on flex items */
}

.banner-title {
  color: #1b3755;
  line-height: 1.2;
  margin-bottom: 2px;
}

.banner-subtitle {
  color: #606060;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.download-btn {
  background-color: #4A7EFF !important;
  border: none;
  border-radius: 100px;
  padding: 8px 20px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  color: #ffffff !important;
}

.download-btn:hover,
.download-btn:active,
.download-btn:focus,
.download-btn:visited {
  background-color: #174a75 !important;
  color: #ffffff !important;
}

.color-606060 {
  color: #606060 !important;
}

/* Make it visible only on mobile viewports */
@media (max-width: 1028px) {
  .mobile-app-banner {
    display: block;
  }
}
</style>
